// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CdEnvironment } from '@coin-depo-config/types';

export const environment: CdEnvironment = {
  production: false,
  serverUrl: 'https://app-ric.coindepo.io/api/',
  serverAuthUrl:  'https://app-ric.coindepo.io/',
  staticUrlIcon: 'https://static.coindepo.io/icons/',
  landingUrl: 'https://ric.coindepo.io',
  fileDomen: 'https://app-ric.coindepo.io',
  staticUrl: 'https://dev-static.coindepo.io/',
  env: 'dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
